import { FC,useState } from "react"

import Modal from "../modal";
import { StatisticsObjectType } from "./types";

const CustomButtonRight: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  const [showingModal, setModal] = useState(false);
  const [title, setTitle] = useState("");




  const openModal = (title: string) => {
    setTitle(title);
    setModal(true);
    document.body.style.overflow = 'hidden';
  };

  return (
    <div className="d-flex flex-column flex-fill">

        {showingModal ? <Modal title={title} data={title === "New Practices" ? StatisticsObjectType.new_practices.data : StatisticsObjectType.new_doctors.data} onClick={() => setModal(false)}></Modal> : null}


      <div className="card mb-3 d-flex flex-fill">
        <div className="row m-0 flex-fill">
          <div className="card-header bg-success-subtle col-6 text-center align-items-center d-flex justify-content-center border-0">
            <h1 className="mt-2 mb-0" style={{color:'#008853', fontSize:'1.875rem'}}>Cases Total</h1>
          </div>
          <div className="card-body col-6 d-flex justify-content-center align-items-center">
            <h1 className="mt-2 mb-0">{StatisticsObjectType.case_total_with_ecr}</h1>
          </div>
        </div>
      </div>
      <div className="card mb-3 flex-fill">
        <div className="row m-0 flex-fill">
          <div className="card-header bg-success-subtle col-6 text-center align-items-center d-flex justify-content-center border-0">
            <h1 className="mt-2 mb-0" style={{color:'#008853', fontSize:'1.875rem'}}>New Practices</h1>
          </div>
          <div className="card-body col-6 text-center  d-flex justify-content-center align-items-center" onClick={() => {
            openModal("New Practices")
          }}>
            <h1 className="btn-link fw-bold text-center m-0">{StatisticsObjectType.new_practices.count}</h1>
          </div>
        </div>
      </div>
      <div className="card mb-3 flex-fill">
        <div className="row m-0 flex-fill">
          <div className="card-header bg-success-subtle col-6 text-center align-items-center d-flex justify-content-center border-0">
            <h1 className="mt-2 mb-0" style={{color:'#008853', fontSize:'1.875rem'}}>New Doctors</h1>
          </div>
          <div className="card-body col-6 text-center d-flex justify-content-center align-items-center" onClick={() => {
            openModal("New Doctors")
          }}>
            <h1 className="btn-link fw-bold text-center m-0">{StatisticsObjectType.new_doctors.count}</h1>
          </div>
        </div>
      </div>
      <div className="card mb-3 flex-fill">
        <div className="row m-0 flex-fill">
          <div className="card-header bg-success-subtle col-6 text-center align-items-center d-flex justify-content-center border-0">
            <h1 className="mt-2 mb-0" style={{color:'#008853', fontSize:'1.875rem'}}>Transfers</h1>
          </div>
          <div className="card-body col-6 text-center d-flex justify-content-center align-items-center">
            <h1 className="mt-2 mb-0">{StatisticsObjectType.transfers === null ? `0 %` : StatisticsObjectType.transfers}</h1>
          </div>
        </div>
      </div>
    </div>
  )
}
export default CustomButtonRight;
